import React from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { generateId, shortHandDateTime, translate } from '../../utility/functions';
import Button from '../../forms/Button';
import Table from '../../table/Table';
import GetState from '../../GetState';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';

const Wallet = ({ children, ...props }) => {
    const { guid } = useParams();

    const [data, refreshData] = GetState(QuestRoute.user.wallet(guid));

    const voidCode = code => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to Void this Code?`,
                type: 'warning',
            },
            promise: {
                title: 'Voiding',
                body: `Voiding ${code}`,
                callback: () => HamQuest.put(QuestRoute.codes.void(code), { isVoided: true })
            },
            confirmed: {
                title: 'Success',
                body: `${code} successfully voided.`,
                type: 'success'
            },
            finally: () => refreshData()
        })
    }

    const tableConfig = {
        data: data,
        label: 'Wallet',
        headers: [
            {
                label: 'Type',
                propKey: 'itemType',
                options: true,
            }, {
                label: 'Name',
                propKey: 'name',
                options: true,
            }, {
                label: 'Code',
                propKey: 'code',
            }, {
                label: 'Max Uses',
                propKey: 'maxUses',
            }, {
                label: 'Use Count',
                propKey: 'useLimitCount',
            }, {
                label: 'Purchased/Claim',
                propKey: 'purchasedDate',
                type: 'date'
            }
        ],
        renderFormat: (e) => (
            <ManagementRow
                key={generateId()}
                controls={[<Button key={generateId()} label='Void' onClick={() => voidCode(e.code)} />]}
            >
                <td>{translate(e.itemType)}</td>
                <td>{e.name}</td>
                <td>{e.code}</td>
                <td>{e.maxUses}</td>
                <td>{e.useLimitCount}</td>
                <td>{shortHandDateTime(e.purchasedDate)}</td>
            </ManagementRow>
        )
    }

    return <Table config={tableConfig} />;
}

export default Wallet;
